import type {
    ArrayScreenDescription,
    ArrayContentDescription,
    InputOutputTables,
    ComponentDescription} from "../description";
import {
    ArrayScreenFormat
} from "../description";
import { assert, defined } from "../../Support";
import type { ArrayContentHandler } from "./array-content";
import type { ComponentBuilder, AppDescriptionContext, PropertyDescriptor } from "../components";
import type { SerializedComponent } from "../../components/SerializedApp";
import type { ScreenWithMenuItemsContent } from "../builder-utils";
import type { IconName } from "../../named-icons";

export interface ArrayScreenHandler<
    TContentDesc extends ArrayContentDescription,
    TScreenDesc extends ArrayScreenDescription & TContentDesc
> extends ArrayContentHandler<TContentDesc> {
    readonly label: string;
    readonly icon: IconName;
    readonly isLegacy: boolean;
    readonly supportsInlineList: boolean;

    makeScreenContent(
        builder: ComponentBuilder,
        screenName: string,
        desc: TScreenDesc,
        incomingArrayData: SerializedComponent,
        title: SerializedComponent,
        arrayScreenRow: SerializedComponent,
        uniqueID: string
    ): ScreenWithMenuItemsContent;

    defaultDescription(
        tables: InputOutputTables,
        ccc: AppDescriptionContext,
        components: readonly ComponentDescription[]
    ): TScreenDesc | undefined;

    getPropertyDescriptors(
        isTableRefArray: boolean,
        desc: TScreenDesc | undefined,
        isDefaultArrayScreen: boolean,
        withTransforms: boolean,
        ccc: AppDescriptionContext
    ): readonly PropertyDescriptor[];
    getPropertyAndActionDescriptors(
        isTableRefArray: boolean,
        desc: TScreenDesc | undefined,
        isDefaultArrayScreen: boolean,
        withTransforms: boolean,
        ccc: AppDescriptionContext
    ): readonly PropertyDescriptor[];
}
export const allArrayScreenHandlers: ArrayScreenHandler<ArrayContentDescription, ArrayScreenDescription>[] = [];

export function registerArrayScreenHandler(
    handler: ArrayScreenHandler<ArrayContentDescription, ArrayScreenDescription>
): void {
    assert(allArrayScreenHandlers.every(h => h.format !== handler.format));
    allArrayScreenHandlers.push(handler);
}

export function handlerForArrayScreenFormat(
    format: ArrayScreenFormat
): ArrayScreenHandler<ArrayContentDescription, ArrayScreenDescription> | undefined {
    return allArrayScreenHandlers.find(h => h.format === format);
}

export function getDefaultArrayScreenHandler(): ArrayScreenHandler<ArrayContentDescription, ArrayScreenDescription> {
    return defined(handlerForArrayScreenFormat(ArrayScreenFormat.List));
}
